import script from "./CustomPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPopup.vue?vue&type=script&setup=true&lang=js"

import "./CustomPopup.vue?vue&type=style&index=0&id=43e9260e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e9260e"]])

export default __exports__